import { FunctionComponent, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import {
    TicketsOverviewContainerProps,
    TicketsOverviewContainer,
} from './ticketsOverviewUIContainer';
import { initI18nNextTicketOverview } from '../lib/i18n/initI18n';

type TicketsOverviewUIProps = {
    locale?: string;

    translations?: {
        en?: Record<string, string>;
        de?: Record<string, string>;
    };
} & TicketsOverviewContainerProps;

export const TicketsOverviewUI: FunctionComponent<TicketsOverviewUIProps> = ({
    locale = 'de',
    translations,
    ...props
}) => {
    const i18n = useMemo(
        () =>
            initI18nNextTicketOverview({
                lng: locale,
                translations,
            }),
        []
    );

    if (locale !== i18n.language) {
        i18n.changeLanguage(locale);
    }

    return (
        <I18nextProvider i18n={i18n}>
            <TicketsOverviewContainer {...props} />
        </I18nextProvider>
    );
};
